<template>
  <v-card elevation="6" class="my-4 mx-4">
    <v-card-title class="mx-5" style="color:#AF8936">
      <div>
        <h2 class="hidden-sm-and-down">Consultar Toca Electrónico</h2>
        <h4  style="color:#225883">
          {{ getUser.nombre }} {{ getUser.primer_apellido }}
          <span v-if="getUser.segundo_apellido">
            {{ getUser.segundo_apellido }}
          </span>
        </h4>
      </div>
      <!-- <div class="flex-grow-1"></div> -->
    </v-card-title>
    <v-form class="mx-5" @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
      <v-card flat>
        <!-- <h4 style="color:#AF8936">Busqueda:</h4> -->
        <v-card-text>
          <v-row>
            <!-- <v-col cols="12" md="3">
              <v-text-field
                v-model="num_carpeta"
                label="Carpeta"
                prepend-inner-icon="mdi-folder-outline"
                outlined
                clearable
                dense
                hint="Ej. 1/2024"
                :rules="[rules.tocaRules]"
              >
              </v-text-field>
            </v-col> -->
            <v-col cols="12" md="3">
              <v-text-field
                v-model="num_toca"
                label="Toca"
                prepend-inner-icon="mdi-file-document-outline"
                outlined
                clearable
                dense
                hint="Ejemplo: 1/2024"
                :rules="[rules.tocaRules]"
                @blur="clear()"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                :items="salasList"
                v-model="sala"
                label="Sala"
                prepend-inner-icon="mdi-gavel"
                item-value="id"
                item-text="nombre"
                clearable
                outlined
                dense
                >
              </v-select>
            </v-col>

            <v-col cols="12" md="1" class="ml-5">
            <v-btn
              :loading="loadingTable"
              block
              class="white--text"
              color="grey darken-1"
              @click="clickSearch()"
              :disabled="!valid"
            >
              Buscar
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>

        </v-card-text>
      </v-card>

      <v-card>
        <div v-if="showAlert">
          <v-alert
            prominent
            outlined
            type="error"
           >
            <v-row align="center">
              <v-col class="grow hidden-xs-only">No se encontraron registros relacionados con la busqueda.</v-col>
              <v-col class="grow hidden-sm-and-up">No hay registros.</v-col>
            </v-row>
          </v-alert>
        </div>
        <div v-if="showTabla">
          <template>
            <v-card-title  style="color:#AF8936">
              <h5>{{ titleTabla }}</h5>
              <div class="flex-grow-1"></div>
            </v-card-title>
            <v-data-table
              dense
              light
              actions
              :loading="loadingTable"
              :headers="headers"
              :items="tocasList"
              item-key="id"
              :page.sync="page"
              :items-per-page="per_page_table"
              hide-default-footer
              @page-count="pageCount = $event"
              no-data-text="No hay autorizaciones por mostrar"
            >

            <!-- <template v-slot:item.toca="{ item }">
              <span v-if="item.toca.complemento">{{ item.toca.numero }}/{{ item.toca.anio }}-{{ item.toca.complemento }}</span>
              <span v-else>{{ item.toca.numero }}/{{ item.toca.anio }}</span>
            </template> -->

            <template v-slot:item.sala="{ item }">
              Sala {{ item.sala_id }}
            </template>

            <template v-slot:item.fecha_autorizacion="{ item }" >
              <td><span v-if="item.fecha_autorizacion">{{item.fecha_autorizacion | formatDate}} {{ }}</span><br>
              </td>
            </template>

            <template v-slot:item.estatus="{ item }">
              <v-chip v-if="estaRevocada(item)" small color="red" text-color="white">
                Revocado
              </v-chip>
              <v-chip v-else small color="green" text-color="white">
                Activo
              </v-chip>
            </template>

              <template v-slot:item.action="{ item }">
                <v-btn
                  v-if="!estaRevocada(item)"
                  class="mx-2"
                  dark
                  x-small
                  color="blue-grey darken-2"
                  @click="showToca(item)"
                >
                  <v-icon small dark left>mdi-file-eye </v-icon>
                  Ver Toca
                </v-btn>
                <v-tooltip v-else top>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-chip small color="red lighten-4" class="red--text text--darken-2">
                        <v-icon small left color="red">mdi-lock</v-icon>
                        Acceso revocado
                      </v-chip>
                    </span>
                  </template>
                  <span>Sus permisos fueron revocados el {{ fechaRevocacion(item) | formatDate }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
            <div class="text-center pt-2">
              <v-pagination
                v-if="pagination.last_page > 1 && tocasList.length"
                v-model="pagination.current"
                :length="pagination.last_page"
                :total-visible="7"
                @input="onPageChange"
                color="#1D2E4B"
              ></v-pagination>
            </div>
          </template>
        </div>
      </v-card>
    </v-form>
    <br>
  </v-card>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from 'vuex'

  export default {
    data: () => ({
      // dialog:false,
      valid: true,
      loading:false,
      sala: '',
      num_toca: '',
      page: 1,
      pageCount: 0,
      per_page_table: 20,
      pagination: {
        current: 1,
        last_page: 0,
        total: 0
      },
      showTabla: false,
      showAlert: false,
      titleTabla: 'REGISTROS:',
      headers: [
        { text: 'Toca', value: 'num_toca' },
        { text: 'Expediente', value: 'num_expediente' },
        { text: 'Sala', value: 'sala' },
        { text: 'Fecha de autorización', value: 'fecha_autorizacion' },
        { text: 'Estatus', value: 'estatus', sortable: false },
        { text: 'Acciones', value: 'action', sortable: false }
      ],
      loadingTable: false,
      salasList: [
        { id:'1', nombre: 'PRIMERA SALA ESPECIALIZADA EN MATERIA PENAL'},
        { id:'2', nombre: 'SEGUNDA SALA ESPECIALIZADA EN MATERIA PENAL' },
        { id:'6', nombre: 'SEXTA SALA ESPECIALIZADA EN MATERIA PENAL'},
        { id:'10', nombre: 'DÉCIMA SALA ESPECIALIZADA EN JUSTICIA INTEGRAL PARA ADOLESCENTES Y PENAL' },
        { id:'11', nombre: 'DÉCIMA PRIMERA SALA ESPECIALIZADA EN MATERIA PENAL'},
        { id:'12', nombre: 'DÉCIMA SEGUNDA SALA'},
      ],
      tocasList: [],
      rules: {
          required:v => !!v || 'Campo requerido',
          requiredSelect:v => !!v|| 'Campo requerido',
          tocaRules:v => /^(\d+)(\/)(\d{4})(\-[A-Z]+)*$/.test(v) || 'Ingrese formato válido, Ejemplos: 1/2024, 1/2024-A',
        },
      // distritos:[
      //   { id: 1, nombre: 'Distrito I -Tonalá' }
      // ]
    }),
    computed: {
      ...mapGetters([
        // "ordenesList","d ataNotFound", "getUser", "listJueces","roleUser"
        "getUser", "listJueces"
      ])
    },
    watch: {
      num_toca: function (val) {
        this.pagination.current = 1;
        if(!val){
          // this.valid = true;
          this.buscarToca()
          return this.$refs.form.resetValidation()
        }
      },
      sala: function (val) {
        this.pagination.current = 1;
        this.buscarToca()
        if(!val){
          return this.$refs.form.resetValidation()
        }
      }
    },
    mounted(){
      this.buscarToca()
    },
    methods: {
      estaRevocada (item) {
        return !!(item.esta_revocada || item.fecha_revocacion)
      },
      fechaRevocacion (item) {
        return item.fecha_revocacion || null
      },
      clickSearch(){
        this.titleTabla = 'RESULTADO DE LA BUSQUEDA:'
        // this.loadingTable = true
        this.buscarToca()
      },
      clear(){
        if (!this.num_toca) {
          this.$refs.form.resetValidation()
        }
      },
      onPageChange() {
        this.buscarToca();
      },
      buscarToca() {
        // if (!this.sala) {
        //   Swal.fire({
        //     icon: 'warning',
        //     title: 'Seleccione sala',
        //     text: 'Es necesario seleccionar una sala para continuar con la búsqueda ',
        //     confirmButtonText: "Aceptar",
        //   })
        //   return false
        // }
        this.tocasList = []
        this.loadingTable = true;
        this.$store.dispatch("GET_TOCAS", {
          url:"/autorizaciones" ,
          params: {
            // numero:this.numero,
            // anio:this.anio,
            // complemento:this.complemento,
            sala_id: this.sala,
            page: this.pagination.current,
            num_toca: this.num_toca
            // user_id: this.getUser.id
          }
        })
        .then((response) => {
          if (response.data.status == 'ok') {
            this.showTabla = true
            this.showAlert = false
            var autorizaciones = response.data.autorizaciones
            var items = autorizaciones && Array.isArray(autorizaciones.data) ? autorizaciones.data : []
            this.tocasList = items
            if (autorizaciones) {
              this.pagination.current = autorizaciones.current_page
              this.pagination.last_page = autorizaciones.last_page
              this.pagination.total = autorizaciones.total
              this.per_page_table = autorizaciones.per_page
            }
          } else {
            this.showAlert = true
            this.showTabla = false
            this.tocasList = []
          }
          if (!response.data.success && !response.data.status) {
            Swal.fire({
              icon: 'error',
              title: response.data.message,
              text: response.data.errors,
              confirmButtonText: "Aceptar"
            })
          }
          this.numero = '';
          this.anio = '';
          this.complemento = '';
          this.loadingTable = false;
        })
        .catch(err => {
          console.log(err);
          this.showAlert = true
          this.showTabla = false
          this.loadingTable = false;
        });

      },
      showToca(item){
        if (this.estaRevocada(item)) {
          Swal.fire({
            icon: 'warning',
            title: 'Permisos revocados',
            html: 'Sus permisos para consultar el toca <b>' + item.num_toca + '</b> fueron revocados el <b>' + this.$options.filters.formatDate(this.fechaRevocacion(item)) + '</b>.',
            confirmButtonText: "Aceptar",
          })
          return
        }
        localStorage.setItem("currentToca", JSON.stringify( item ));
        this.$router.push({name: 'TocasShow'});
      },
    }
  };
</script>
